import React from "react";
import { DisabledPrompt, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { Transaction } from "model";

import { UIIconButton } from "components/ui/UIButton";
import { ImageAsset, SVGAsset } from "res";

import "./styles.css";

/**
 * @function TransactionDetailsView
 * @param {Transaction} transaction - The transaction that should be shown
 * @return {React.Component}
 * @exported true
 * @description The is the view for the TransactionDetailsPage
 * @example
 * <TransactionDetailsView transaction={ transaction } />
 */
export default function TransactionDetailsView(props) {
  const transaction = props.transaction ?? Transaction.firstInstanceOf();
  const merchant = transaction.merchant;
  const card = transaction.card;

  const cardName = card.type.charAt(0).toUpperCase() + card.type.slice(1);
  const cardNumber = card.number.substring(card.number.length - 4, card.number.length);

  const navigate = useRoute();
  const cardID = useParams().cardID ?? transaction.card.id;
  const transactions = Transaction.getByCard(cardID);

  const index = transactions.findIndex(item => item.id === transaction.id);

  const prevTransaction = transactions[index - 1];
  const nextTransaction = transactions[index + 1];

  const prevBtn = evt => navigate(`/home/transactiondetails/${ cardID }/${ prevTransaction.id }`);
  const nextBtn = evt => navigate(`/home/transactiondetails/${ cardID }/${ nextTransaction.id }`);

  return (
    <div className="transaction-details-view flex-container flex-vertical center">
      <div className="text-center">
        <div className="flex-container flex-horizontal align-center-container">
          { prevTransaction !== undefined &&
            <div className="left-chevron clickable">
              <SVGAsset id="LeftChevronIcon" className="chevron-icon" onClick={ prevBtn } />
            </div> }

          <div className="flex-container flex-vertical flex-width">
            <div className="set-width">
              <ImageAsset id={ merchant.logo } className="transaction-logo" data-point="Transaction_Details_Merchant_Logo"/>
            </div>
            <p className="transaction-biller sub-text" data-point="Transaction_Details_Merchant_Name">{ merchant.name }</p>
            <p className="transaction-total" data-point="Transaction_Details_Amount"><b>{ transaction.amount.format() }</b></p>
          </div>

          { nextTransaction !== undefined &&
            <div className="right-chevron clickable">
              <SVGAsset id="RightChevronIcon"  className="chevron-icon" onClick={ nextBtn } />
            </div> }
        </div>
        <div className="transaction-info-group sub-text">
          <p className="group" data-point="Transaction_Details_Merchant_Group"><b>{ merchant.group }</b></p>
          <p>{ transaction.locationOfPurchase }</p>
        </div>
      </div>
      <div className="flex-container flex-horizontal sub-text">
        <div className="flex-container flex-width flex-vertical">
          <p data-point="Transaction_Details_Card"><b>{ cardName } *{ cardNumber }</b></p>
          <p data-point="Transaction_Details_Status">{ transaction.status }</p>
        </div>
        <div className="flex-container flex-width flex-vertical text-right">
          <p data-point="Transaction_Details_Date"><b>{ transaction.purchaseDate.format("D, M d, Y") }</b></p>
          <p>{ transaction.purchaseDate.format("h:i p") }</p>
        </div>
      </div>
      <div className="map-container" data-point="Transaction_Details_Map">
        <ImageAsset id="MapLocationImage" className="map" />
      </div>
      <p>{ merchant.name }</p>
      <p><span data-point="Transaction_Details_Merchant_Street">{ merchant.street }</span></p>
      <p>{ merchant.city }, { merchant.state } { merchant.zip }, { merchant.country }</p>
      <div className="flex-container flex-horizontal button-container">
        <DisabledPrompt>
          <UIIconButton icon={<SVGAsset id="PhoneIcon" />} text="Call" className="set-width" dataPoint="Transaction_Details_Call" />
        </DisabledPrompt>
        <DisabledPrompt>
          <UIIconButton icon={<SVGAsset id="OutsideLinkIcon" />} text="Website" className="set-width" dataPoint="Transaction_Details_Website" />
        </DisabledPrompt>
        <DisabledPrompt>
          <UIIconButton icon={<SVGAsset id="ClockIcon" />} text="Hours" className="set-width" dataPoint="Transaction_Details_Hours" />
        </DisabledPrompt>
      </div>
    </div>
  );
}